import { Modal } from "antd";
import { notify } from "@/shared/utils/notify";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  brandsChangeModalState,
  deleteBrand,
  refreshTableBrands,
  setBrandForUpdate,
  setIsBrandForUpdate,
} from "../../../redux";
import { DataBrands } from "../../../redux/@types";
import useAppDispatch from "../../../redux/hooks/useAppDispatch";
import { useBrands } from "./useBrands";

const { confirm } = Modal;

export const useTableBrands = () => {
  const dispatch = useAppDispatch();
  const { tableProps } = useBrands();

  const changeBrandForUpdate = (val: DataBrands) => {
    dispatch(setIsBrandForUpdate(true));
    dispatch(setBrandForUpdate(val));
    dispatch(brandsChangeModalState());
  };

  const showDeleteConfirm = (valId: number, val: string) => {
    confirm({
      title: `Estás seguro de borrar la Marca con el id: ${valId}`,
      icon: <ExclamationCircleOutlined />,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}", si deseas continuar dale click a "Borrar marca" en caso tal solo oprime en "Cancelar".`,
      okText: "Borrar marca",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        await deleteBrand(valId)
          .then((res) => {
            dispatch(refreshTableBrands(true));
            if(res[0].name){
              notify.success(`Se ha borrado con éxito la Marca con id:${valId}`);
            }else if(res){
              console.log({res})
              notify.error(`${res}`);
            }
            tableProps?.refresh();
          })
          .catch((err) => {
            console.log({ err });
            notify.error(err.message);
          });
      },
      onCancel() {},
    });
  };

  return {
    //state
    //methods
    //functions
    changeBrandForUpdate,
    showDeleteConfirm,
  };
};
